import PartsListComponent from 'src/components/features/superAdmin/partsListComponent';

const ListPartPage = () => <PartsListComponent />;

export default ListPartPage;
